import NavigationItem from "app/models/navigationItem";

import { ReactComponent as Explore } from "app/assets/icons/explore-outline.svg";
import { ReactComponent as Portfolio } from "app/assets/icons/wallet-outline.svg";
import { ReactComponent as TrendUp } from "app/assets/icons/trend-up.svg";
import { ReactComponent as Earn } from "app/assets/icons/percent-outline.svg";
import { ReactComponent as Spend } from "app/assets/icons/spend-outline.svg";
import { ReactComponent as Profile } from "app/assets/icons/profile-outline.svg";
import { ReactComponent as ConnectIcon } from "app/assets/icons/peer_chain.svg";
// import { ReactComponent as RampIcon } from "app/assets/icons/ramp.svg";
import { ReactComponent as CustomersIcon } from "app/assets/icons/customers.svg";
import { ReactComponent as TransfersIcon } from "app/assets/icons/arrows-opposite-direction.svg";


const appLinks: NavigationItem[] = [
  {
    label: "Explore",
    url: "/",
    icon: Explore,
    mode: ["business", "personal", "individual-customer", "business-customer"],
  },
  {
    label: "My wallets",
    url: "/spot",
    icon: Portfolio,
    exact: false,
    mode: ["business", "personal", "individual-customer", "business-customer"],
  },
  {
    label: "Customers",
    url: "/customers",
    icon: CustomersIcon,
    exact: false,
    mode: ["business"],
  },
  {
    label: "Transfers",
    url: "/transfers",
    icon: TransfersIcon,
    exact: false,
    mode: ["business"],
  },
  {
    label: "Trade",
    url: "/trade",
    icon: TrendUp,
    exact: false,
    mode: ["business", "personal", "individual-customer", "business-customer"],
  },
  // {
  //   label: "Ramp",
  //   url: "/ramp",
  //   icon: RampIcon,
  //   children: [{ label: "Transfers", url: "/ramp" }],
  // },
  {
    label: "Spend",
    url: "/airtime",
    icon: Spend,
    mode: ["personal"],
    countries: ["NG", "UK"],
    children: [
      { label: "Airtime", url: "/airtime" },
      { label: "Data", url: "/data" },
      { label: "Sports Bet", url: "/sports-bet" },
      { label: "Vouchers", url: "/vouchers" },
    ],
  },
  {
    label: "Earn",
    url: "/yield",
    icon: Earn,
    exact: false,
    mode: ["business", "personal", "individual-customer", "business-customer"],
  },
];

export const profileLink: NavigationItem = {
  label: "Profile",
  url: "/profile",
  icon: Profile,
  exact: false,
  mode: ["business", "personal", "individual-customer", "business-customer"],
};

export const merchantLinks = [
  { url: "/connect", label: "Connect", icon: ConnectIcon },
];

export default appLinks;
